import script from "./TextQuiz.vue?vue&type=script&setup=true&lang=js"
export * from "./TextQuiz.vue?vue&type=script&setup=true&lang=js"

import "./TextQuiz.vue?vue&type=style&index=0&id=7cd8967a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cd8967a"]])

export default __exports__